import { render, staticRenderFns } from "./LangSelectComponent.vue?vue&type=template&id=6aa71928&scoped=true"
import script from "./LangSelectComponent.vue?vue&type=script&lang=js"
export * from "./LangSelectComponent.vue?vue&type=script&lang=js"
import style0 from "./LangSelectComponent.vue?vue&type=style&index=0&id=6aa71928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa71928",
  null
  
)

export default component.exports